import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";

@Injectable({ providedIn: "root" })
export class UserService {
  constructor(private storageService: StorageService) {}

  getCurrentUser(): any {
    const user: string | null = this.storageService.getUser();
    if (user) {
      return JSON.parse(user);
    }
    return user;
  }
}
